import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from './alertDialog.slice';
import { runAcceptHandler, runCancelHandler } from './alertDialog.thunk';
import { selectAlertDialogProps } from './alertDialog.selectors';

/**
 * Simple alert dialog hook that provides access to its state and to methods that:
 *  - opens it with all the needed setup (texts, settings and handlers)
 *  - accepts it and runs the accepting handler
 *  - dismisses it and runs the canceling handler
 */
const useAlertDialog = () => {
  const dispatch = useDispatch();

  const { isOpen, texts, settings } = useSelector(selectAlertDialogProps);

  const openAlertDialog = ({ updatedTexts, updatedSettings, acceptHandler, cancelHandler }) => {
    dispatch(
      openDialog({
        texts: updatedTexts,
        settings: updatedSettings,
        acceptHandler,
        cancelHandler,
      }),
    );
  };

  const onAcceptAlertDialog = () => dispatch(runAcceptHandler());
  const onCloseAlertDialog = () => dispatch(runCancelHandler());

  return {
    isOpen,
    texts,
    settings,
    openAlertDialog,
    onAcceptAlertDialog,
    onCloseAlertDialog,
  };
};

export default useAlertDialog;
